module.exports = __webpack_public_path__ + "img/798.dead735f.png";